import { useLocale } from "next-intl";
import styles from "./preview-frame.module.css";
import { CiDesktop } from "react-icons/ci";
import { FiTablet } from "react-icons/fi";
import { CiMobile1 } from "react-icons/ci";
import { MdClose } from "react-icons/md";
import React, { useState } from "react";

function getInitialViewType(
  isXs: boolean,
  isSm: boolean,
  isMd: boolean,
  isLg: boolean
): ViewType {
  if (isXs || isSm) {
    return ViewType.MOBILE;
  }
  if (isMd) {
    return ViewType.TABLET;
  }
  if (isLg) {
    return ViewType.DESKTOP;
  }
  return ViewType.MOBILE;
}

export default function PreviewFrame({
  listingId,
  onClose,
  isXs,
  isSm,
  isMd,
  isLg,
}: {
  listingId: string;
  onClose: () => void;
  isXs: boolean;
  isSm: boolean;
  isMd: boolean;
  isLg: boolean;
}) {
  const locale = useLocale();
  const initialViewType = getInitialViewType(isXs, isSm, isMd, isLg);
  const [viewType, setViewType] = useState<ViewType>(initialViewType);

  return (
    <div className={styles.listingPreview}>
      <div className={styles.frameWrapper}>
        <div
          className={styles.closeButton}
          onClick={(e) => {
            e.preventDefault();
            onClose();
          }}
        >
          <MdClose />
        </div>
        <iframe
          src={`https://www.doomum.com/${locale}/listing/${listingId}`}
          width="90%"
          height="90%"
          className={`${styles.iframe} ${
            viewType === ViewType.MOBILE && styles.mobile
          } ${viewType === ViewType.TABLET && styles.tablet} ${
            viewType === ViewType.DESKTOP && styles.desktop
          }`}
          style={{ border: "none" }}
          title="Listing Preview"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
        <div className={styles.buttonsWrapper}>
          <button
            className={styles.viewButton}
            onClick={(e) => setViewType(ViewType.MOBILE)}
          >
            <CiMobile1 />
          </button>
          <button
            className={styles.viewButton}
            onClick={(e) => setViewType(ViewType.TABLET)}
          >
            <FiTablet />
          </button>
          <button
            className={styles.viewButton}
            onClick={(e) => setViewType(ViewType.DESKTOP)}
          >
            <CiDesktop />
          </button>
        </div>
      </div>
    </div>
  );
}

const enum ViewType {
  MOBILE = "mobile",
  TABLET = "tablet",
  DESKTOP = "desktop",
}
